import React from "react";
import "../css/CorrectionModal.css";
import {
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
} from "@mui/material";

const CorrectionModal = ({
  reasonForCorrection,
  onCorrectNeeded,
  isLoading,
  value,
  correctionOptions,
  allowMultipleSelection = false,
}) => {
  return (
    <div className="modal">
      <h2 className="heading" data-testid="correction-needed-heading">Correction Needed</h2>
      <form onSubmit={onCorrectNeeded}>
        {allowMultipleSelection ? (
          <FormGroup>
            {correctionOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={Array.isArray(value) ? value.includes(option.value) : false}
                    onChange={reasonForCorrection}
                    value={option.value}
                  />
                }
                label={option.label}
              />
            ))}
          </FormGroup>
        ) : (
          <RadioGroup value={value} onChange={reasonForCorrection}>
            {correctionOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        )}
        <button type="submit" className="submitButton" data-testid="correction-submit-button">
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Submit"
          )}
        </button>
      </form>
    </div>
  );
};

export default CorrectionModal;
